import { ReactNode } from 'react';

type DataTextProps = {
  children: ReactNode;
};

export const DataText = ({ children }: DataTextProps) => (
  <span className="min-w-0 max-w-full whitespace-pre-wrap break-words text-m-r text-base-5">{children}</span>
);
